/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./LayoutCenterRewardRecord.vue?vue&type=template&id=079678ae&scoped=true"
import script from "./LayoutCenterRewardRecord.vue?vue&type=script&lang=js"
export * from "./LayoutCenterRewardRecord.vue?vue&type=script&lang=js"
import style0 from "./LayoutCenterRewardRecord.vue?vue&type=style&index=0&id=079678ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079678ae",
  null
  
)

export default component.exports